export interface ProductSearchResponse {
    /* API endpoint form requesting further results */
    nextPage?: string | null;
    /* The total number of results */
    totalCount: number;
    /* current page number */
    currentPageNumber: number;
    /* The search result as html string */
    searchResultHtml: string;
    /* Describes for which category the search was triggered */
    shopArea: string;
    /* Describes Selected Machine */
    selectedMachine: string;
}
